import { BaseObstetricalHistory, ObstetricalHistoryColumnTitle } from "@/Patient/Components/MedicalNote/Obstetric/Form/BaseObstetricalHistory";

class OntarioObstetricalHistory extends BaseObstetricalHistory {
    protected get columnsTitles(): { [index in ObstetricalHistoryColumnTitle]: React.ReactNode } {
        return {
            [ObstetricalHistoryColumnTitle.Date]: <span>{this.getString("SingularYearLabel")}/{this.getString("MonthLabel")}</span>,
            [ObstetricalHistoryColumnTitle.PlaceOfBirth]: this.getString("ObstetricalFile_PlaceOfBirthLabel"),
            [ObstetricalHistoryColumnTitle.GestationalAge]: this.getString("ObstetricalFile_GestationWeeksLabel"),
            [ObstetricalHistoryColumnTitle.DurationOfLabor]: this.getString("ObstetricalFile_LabourLengthLabel"),
            [ObstetricalHistoryColumnTitle.BirthType]: this.getString("ObstetricalFile_TypeOfBirthLabel"),
            [ObstetricalHistoryColumnTitle.Comments]: this.getString("ObstetricalFile_ObstetricalHistoryCommentLabel"),
            [ObstetricalHistoryColumnTitle.Sex]: this.getString("ObstetricalFile_SexMFLabel"),
            [ObstetricalHistoryColumnTitle.BirthWeight]: this.getString("ObstetricalFile_BirthWeightLabel"),
            [ObstetricalHistoryColumnTitle.BreastfedDuration]: <span>{this.getString("BreastfedLabel")} / {this.getString("DurationLabel")}</span>,
            [ObstetricalHistoryColumnTitle.ChildPresentHealth]: this.getString("ObstetricalFile_ChildCurrentHealthLabel")
        };
    }
    protected get columnMaxLength(): { [index in ObstetricalHistoryColumnTitle]: number | null } {
        return {
            [ObstetricalHistoryColumnTitle.Date]: null,
            [ObstetricalHistoryColumnTitle.PlaceOfBirth]: 12,
            [ObstetricalHistoryColumnTitle.GestationalAge]: null,
            [ObstetricalHistoryColumnTitle.DurationOfLabor]: 6,
            [ObstetricalHistoryColumnTitle.BirthType]: 10,
            [ObstetricalHistoryColumnTitle.Comments]: 5000,
            [ObstetricalHistoryColumnTitle.Sex]: 1,
            [ObstetricalHistoryColumnTitle.BirthWeight]: 5,
            [ObstetricalHistoryColumnTitle.BreastfedDuration]: 4,
            [ObstetricalHistoryColumnTitle.ChildPresentHealth]: null
        };
    }
}

export { OntarioObstetricalHistory };
